export const formatNumber = (value, { locale = 'en-US', decimals = 1, minimumDecimals = 0 } = {}) => {
    if (value === null || value === undefined || isNaN(value)) {
        return '';
    }
    return value.toLocaleString(locale, {
        minimumFractionDigits: minimumDecimals,
        maximumFractionDigits: decimals
    });
};
